import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TopicBack = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 20 20">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2137_8890)">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.2925 9.00331H4.98917L9.55084 4.45997C9.96584 4.04997 9.96584 3.38414 9.55084 2.97414C9.13667 2.56331 8.46417 2.56331 8.04917 2.97414L1.67584 9.31081C1.58417 9.40164 1.51834 9.50914 1.46667 9.62247C1.45 9.65747 1.44084 9.69164 1.42917 9.72664C1.40084 9.81164 1.38334 9.89664 1.3775 9.98664C1.375 10.0233 1.37 10.0575 1.37167 10.0941C1.37584 10.2066 1.395 10.3175 1.43667 10.425C1.44 10.4341 1.44 10.4433 1.44417 10.4525C1.44417 10.4541 1.44417 10.455 1.445 10.4566C1.495 10.575 1.56834 10.675 1.65334 10.765C1.6625 10.775 1.66584 10.7875 1.675 10.7975L8.04834 17.1125C8.25584 17.3175 8.5275 17.42 8.79917 17.42C9.07084 17.42 9.34167 17.3175 9.54917 17.1125C9.96417 16.7016 9.96417 16.0366 9.54917 15.6258L4.9875 11.105H17.2908C17.8775 11.105 18.3517 10.635 18.3517 10.0533C18.3533 9.47414 17.8792 9.00331 17.2925 9.00331Z" fill="#FDFDFD"/>
      </g>
      <defs>
      <clipPath id="clip0_2137_8890">
      <rect width="20" height="20" fill="white"/>
      </clipPath>
      </defs>
      </svg>
    </SvgIcon>
  );
}

export default TopicBack;